import { HttpClient } from '@opallabs/api'
import loadCSVRowCount from '../loadCSVRowCount'

const subParamRegex = /sub=([^&]*)/
const getSubParam = () => window.location.search.match(subParamRegex)
const getSubdomain = () => {
  const subParam = getSubParam()

  if (subParam) {
    return `?sub=${subParam[1]}`
  }

  return ''
}

const fetchCount = (params) =>
  HttpClient().post(`/csv_exports/count${getSubdomain()}`, {
    brand_id: params.brandId,
    filter_attributes: params.filterAttributes,
  })

const getCSVRowCount = (params) => (dispatch) =>
  fetchCount(params)
    .then((response) => dispatch(loadCSVRowCount(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getCSVRowCount
